import { View } from "@gluestack-ui/themed";
import { PreProposalScreens } from "@repo/core/screens/PreProposal";

const PreProposalsSelectProductScreen = () => {
  return (
    <View flex={1} h="$full" w="$full">
      <PreProposalScreens.SelectProduct />
    </View>
  );
};

export default PreProposalsSelectProductScreen;
